import { IDate, IUserDocument, IFileSubType, IObjectAudit, ILicenseGoverningDistrict } from "../../../models"

export interface ICredentialDocument {
    Id: string
    AccountId: string
    UserId: string
    CredentialId: string
    CredentialNumber: string
    ExternalId: string
    Name: string
    ComplianceSupervisorName: string
    DoesNotExpire: boolean
    ExpirationDate: IDate
    DaysToExpiration: number
    Completed: IDate
    GoverningDistrictOrState: string
    LicenseGoverningDistricts: ILicenseGoverningDistrict
    Score: number
    Deleted: boolean
    TicksSinceChange: number
    ObjectAudit: IObjectAudit
    Type: ECredentialType
    SubTypeId: string
    CategoryId: string
    SubTypeName: string
    CategoryName: string
    Alias: string
    Note: string
    FileSubType: IFileSubType
    User: IUserDocument
    EmployeeStatusId: string
    EmployeeSubStatusId: string
    IsExpired: boolean
    EmployeeFileId: string
    AssesmentRequestId: number
    DisplayFirstName: string
    HideInEss: boolean
}

export enum ECredentialType {
    License = 0,
    Certification = 1,
    Skill = 2,
    Test = 3
}